"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(walletSaga),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(handleConnectWalletRequest),
    _marked3 = /*#__PURE__*/_regeneratorRuntime.mark(handleEnableWalletRequest),
    _marked4 = /*#__PURE__*/_regeneratorRuntime.mark(handleEnableWalletSuccess),
    _marked5 = /*#__PURE__*/_regeneratorRuntime.mark(handleDisconnectWallet),
    _marked6 = /*#__PURE__*/_regeneratorRuntime.mark(handleFetchWalletRequest),
    _marked7 = /*#__PURE__*/_regeneratorRuntime.mark(handleConnectWalletSuccess),
    _marked8 = /*#__PURE__*/_regeneratorRuntime.mark(handleSwitchNetworkRequest),
    _marked9 = /*#__PURE__*/_regeneratorRuntime.mark(handleSwitchNetworkSucces);

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWalletSaga = exports.walletSaga = void 0;

var effects_1 = require("redux-saga/effects");

var schemas_1 = require("@dcl/schemas");

var decentraland_connect_1 = require("decentraland-connect");

var eth_1 = require("../../lib/eth");

var actions_1 = require("./actions");

var utils_1 = require("./utils");

var selectors_1 = require("./selectors"); // Patch Samsung's Cucumber provider send to support promises


var provider = window.ethereum;
var cucumberProviderSend;

if (eth_1.isCucumberProvider()) {
  var _send = provider.send;

  cucumberProviderSend = function cucumberProviderSend() {
    try {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return Promise.resolve(_send.apply(provider, args)).then(function (accounts) {
        return (accounts === null || accounts === void 0 ? void 0 : accounts.result) || [];
      });
    } catch (err) {
      return Promise.reject(err);
    }
  };
} // Can be set on createWalletSaga


var CHAIN_ID;
var POLL_INTERVAL = 5 * 60 * 1000; // 60 seconds

var polling = false;

function walletSaga() {
  return _regeneratorRuntime.wrap(function walletSaga$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return effects_1.all([effects_1.takeEvery(actions_1.CONNECT_WALLET_REQUEST, handleConnectWalletRequest), effects_1.takeEvery(actions_1.ENABLE_WALLET_REQUEST, handleEnableWalletRequest), effects_1.takeEvery(actions_1.ENABLE_WALLET_SUCCESS, handleEnableWalletSuccess), effects_1.takeEvery(actions_1.FETCH_WALLET_REQUEST, handleFetchWalletRequest), effects_1.takeEvery(actions_1.DISCONNECT_WALLET, handleDisconnectWallet), effects_1.takeEvery(actions_1.CONNECT_WALLET_SUCCESS, handleConnectWalletSuccess), effects_1.takeEvery(actions_1.SWITCH_NETWORK_REQUEST, handleSwitchNetworkRequest), effects_1.takeEvery(actions_1.SWITCH_NETWORK_SUCCESS, handleSwitchNetworkSucces)]);

        case 2:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

exports.walletSaga = walletSaga;

function handleConnectWalletRequest() {
  var _yield$effects_1$race, success, failure;

  return _regeneratorRuntime.wrap(function handleConnectWalletRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return effects_1.put(actions_1.fetchWalletRequest());

        case 3:
          _context2.next = 5;
          return effects_1.race({
            success: effects_1.take(actions_1.FETCH_WALLET_SUCCESS),
            failure: effects_1.take(actions_1.FETCH_WALLET_FAILURE)
          });

        case 5:
          _yield$effects_1$race = _context2.sent;
          success = _yield$effects_1$race.success;
          failure = _yield$effects_1$race.failure;

          if (!success) {
            _context2.next = 13;
            break;
          }

          _context2.next = 11;
          return effects_1.put(actions_1.connectWalletSuccess(success.payload.wallet));

        case 11:
          _context2.next = 14;
          break;

        case 13:
          throw new Error(failure.payload.error);

        case 14:
          _context2.next = 22;
          break;

        case 16:
          _context2.prev = 16;
          _context2.t0 = _context2["catch"](0);
          _context2.next = 20;
          return effects_1.put(actions_1.disconnectWallet());

        case 20:
          _context2.next = 22;
          return effects_1.put(actions_1.connectWalletFailure(_context2.t0.message));

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 16]]);
}

function handleEnableWalletRequest(action) {
  var _this = this;

  var providerType, account;
  return _regeneratorRuntime.wrap(function handleEnableWalletRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          providerType = action.payload.providerType;
          _context4.prev = 1;
          _context4.next = 4;
          return effects_1.call(function () {
            return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
              var _yield$decentraland_c, account;

              return _regeneratorRuntime.wrap(function _callee$(_context3) {
                while (1) {
                  switch (_context3.prev = _context3.next) {
                    case 0:
                      if (!eth_1.isCucumberProvider()) {
                        _context3.next = 3;
                        break;
                      }

                      _context3.next = 3;
                      return cucumberProviderSend('eth_requestAccounts');

                    case 3:
                      _context3.next = 5;
                      return decentraland_connect_1.connection.connect(providerType, CHAIN_ID);

                    case 5:
                      _yield$decentraland_c = _context3.sent;
                      account = _yield$decentraland_c.account;
                      return _context3.abrupt("return", account);

                    case 8:
                    case "end":
                      return _context3.stop();
                  }
                }
              }, _callee);
            }));
          });

        case 4:
          account = _context4.sent;

          if (account) {
            _context4.next = 7;
            break;
          }

          throw new Error('Enable did not return any accounts');

        case 7:
          _context4.next = 9;
          return effects_1.put(actions_1.enableWalletSuccess(providerType));

        case 9:
          _context4.next = 17;
          break;

        case 11:
          _context4.prev = 11;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 15;
          return effects_1.put(actions_1.disconnectWallet());

        case 15:
          _context4.next = 17;
          return effects_1.put(actions_1.enableWalletFailure(_context4.t0.message));

        case 17:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked3, null, [[1, 11]]);
}

function handleEnableWalletSuccess(_action) {
  return _regeneratorRuntime.wrap(function handleEnableWalletSuccess$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return effects_1.put(actions_1.connectWalletRequest());

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked4);
}

function handleDisconnectWallet(_action) {
  return _regeneratorRuntime.wrap(function handleDisconnectWallet$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return effects_1.call(function () {
            return decentraland_connect_1.connection.disconnect();
          });

        case 3:
          _context6.next = 8;
          break;

        case 5:
          _context6.prev = 5;
          _context6.t0 = _context6["catch"](0);
          console.error(_context6.t0);

        case 8:
          // stop polling wallet balances
          polling = false;

        case 9:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked5, null, [[0, 5]]);
}

function handleFetchWalletRequest(_action) {
  var wallet;
  return _regeneratorRuntime.wrap(function handleFetchWalletRequest$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return effects_1.call(utils_1.buildWallet);

        case 3:
          wallet = _context7.sent;
          _context7.next = 6;
          return effects_1.put(actions_1.fetchWalletSuccess(wallet));

        case 6:
          _context7.next = 12;
          break;

        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](0);
          _context7.next = 12;
          return effects_1.put(actions_1.fetchWalletFailure(_context7.t0.message));

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked6, null, [[0, 8]]);
}

function handleConnectWalletSuccess() {
  var isWalletConnected;
  return _regeneratorRuntime.wrap(function handleConnectWalletSuccess$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!(!polling && POLL_INTERVAL > 0)) {
            _context8.next = 13;
            break;
          }

          polling = true;

        case 2:
          if (!polling) {
            _context8.next = 13;
            break;
          }

          _context8.next = 5;
          return effects_1.delay(POLL_INTERVAL);

        case 5:
          _context8.next = 7;
          return effects_1.select(selectors_1.isConnected);

        case 7:
          isWalletConnected = _context8.sent;

          if (!isWalletConnected) {
            _context8.next = 11;
            break;
          }

          _context8.next = 11;
          return effects_1.put(actions_1.fetchWalletRequest());

        case 11:
          _context8.next = 2;
          break;

        case 13:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked7);
}

function handleSwitchNetworkRequest(action) {
  var chainId, provider, newChainId;
  return _regeneratorRuntime.wrap(function handleSwitchNetworkRequest$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          chainId = action.payload.chainId;
          _context9.next = 3;
          return effects_1.call(eth_1.getConnectedProvider);

        case 3:
          provider = _context9.sent;
          _context9.prev = 4;

          if (provider) {
            _context9.next = 7;
            break;
          }

          throw new Error('Could not get provider');

        case 7:
          _context9.next = 9;
          return effects_1.call([provider, 'request'], {
            method: 'wallet_switchEthereumChain',
            params: [{
              chainId: '0x' + chainId.toString(16)
            }]
          });

        case 9:
          _context9.next = 11;
          return effects_1.put(actions_1.switchNetworkSuccess(chainId));

        case 11:
          _context9.next = 36;
          break;

        case 13:
          _context9.prev = 13;
          _context9.t0 = _context9["catch"](4);

          if (!(provider && _context9.t0.code === 4902)) {
            _context9.next = 34;
            break;
          }

          _context9.prev = 16;
          _context9.next = 19;
          return effects_1.call([provider, 'request'], {
            method: 'wallet_addEthereumChain',
            params: [utils_1.getAddEthereumChainParameters(chainId)]
          });

        case 19:
          _context9.next = 21;
          return effects_1.call([provider, 'request'], {
            method: 'eth_chainId',
            params: []
          });

        case 21:
          newChainId = _context9.sent;

          if (!(chainId !== parseInt(newChainId, 16))) {
            _context9.next = 24;
            break;
          }

          throw new Error('chainId did not change after adding network');

        case 24:
          _context9.next = 26;
          return effects_1.put(actions_1.switchNetworkSuccess(chainId));

        case 26:
          return _context9.abrupt("return");

        case 29:
          _context9.prev = 29;
          _context9.t1 = _context9["catch"](16);
          _context9.next = 33;
          return effects_1.put(actions_1.switchNetworkFailure(chainId, "Error adding network: ".concat(_context9.t1.message)));

        case 33:
          return _context9.abrupt("return");

        case 34:
          _context9.next = 36;
          return effects_1.put(actions_1.switchNetworkFailure(chainId, "Error switching network: ".concat(_context9.t0.message)));

        case 36:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked8, null, [[4, 13], [16, 29]]);
}

function handleSwitchNetworkSucces(_action) {
  return _regeneratorRuntime.wrap(function handleSwitchNetworkSucces$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return effects_1.put(actions_1.fetchWalletRequest());

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked9);
}

function createWalletSaga(options) {
  if (eth_1.isValidChainId(options.CHAIN_ID)) {
    CHAIN_ID = Number(options.CHAIN_ID);
  } else {
    throw new Error("Invalid Chain id ".concat(options.CHAIN_ID, ". Valid options are ").concat(Object.values(schemas_1.ChainId)));
  }

  if (options.MANA_ADDRESS) {
    console.warn('Deprecated notice: the MANA_ADDRESS option on `createWalletSaga` has been deprecated and will be removed in future version.');
  }

  if (options.POLL_INTERVAL) {
    POLL_INTERVAL = options.POLL_INTERVAL;
  }

  if (options.TRANSACTIONS_API_URL) {
    utils_1.setTransactionsApiUrl(options.TRANSACTIONS_API_URL);
  } else {
    console.warn("\"TRANSACTIONS_API_URL\" not provided on createWalletSaga, using default value \"".concat(utils_1.getTransactionsApiUrl(), "\"."));
  }

  return walletSaga;
}

exports.createWalletSaga = createWalletSaga;